module.exports = __webpack_public_path__ + "img/title-1.235bd2b7.png";